import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import markerCss from '../Marker.module.css';
import Label from "../Label";
import LiveHelpIcon from '@material-ui/icons/LiveHelp';
import pokedex from "../../../utils/pokedex";
import css from './NestMarker.module.css';

const NestMarker = (props) => {
	let label = [<div>{props.nest.name} {props.zoom}</div>];
	if( props.nest.pokemon_id )
		label.push(<div className={css.LabelPokemon}>{pokedex[props.nest.pokemon_id]['name']} Nest</div>);

	let icon = null;
	if( props.nest.pokemon_id ) {
		icon = <img alt={props.nest.name} src={'https://www.a2pogo.com/images/pokemon/icons-4/' + props.nest.pokemon_id + '.png'} />;
	} else if( props.zoom > 15 ) {
		icon = <LiveHelpIcon/>;
	}

	return (<>
		{props.infoWindow}
		<div className={markerCss.Marker}>
			<div onClick={() => props.onClick(props.nest)}>
				{icon}
			</div>
			{props.zoom > 15 && <Label text={label} />}
			{/*<Label text={props.pokemon.name}/>*/}
		</div>
	</>);
};

NestMarker.propTypes = {
	nest: PropTypes.object.isRequired,
	onClick: PropTypes.func.isRequired
};

const mapStateToProps = (state) => {
	return {
		zoom: state.map.zoom
	};
};


export default connect(mapStateToProps)(NestMarker);